import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import './Login.css';
// @mui
import { Link, Stack, Button, IconButton, InputAdornment, TextField, Checkbox } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const [loginValue, setLoginValue] = useState('');
  const [passwordValue, setPasswordValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const loginUser = (login, passwords, setIsLoading, setError) => {
    console.log('ooooooo');

    console.log(login, passwords);
    setError(false);
    setIsLoading(true);
    if (!!login && !!passwords) {
      // setTimeout(() => {
      axios
        // .get("http://drdc.rtcsindia.co.in/api/Login",{
        //   email: login,
        //   password: password,
        // })
        .post('http://drdc.rtcsindia.co.in/api/login', {
          username: login,
          password: passwords,
        })
        .then((response) => {
          console.log(response.data);
          if (response.data.success === true) {
            toast('Successfully Login', {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: 0,
              theme: 'light',
            });
            localStorage.setItem('id_token', `Bearer ${response.data.token.token}`);
            setError(null);
            setIsLoading(false);
            navigate('/dashboard', { replace: true });
          }
        })
        .catch((error) => {
          toast('Invalid Username And password', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: 0,
            theme: 'light',
          });
        });
      // }, 1000);
    } else {
      // dispatch({ type: "LOGIN_FAILURE" });
      setError(true);
      setIsLoading(false);
      toast('Invalid Username And password', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: 0,
        theme: 'light',
      });
    }
  };
  const changeUsername = (e) => {
    console.log(e.target.value);
    setLoginValue(e.target.value);
  };
  const changePassword = (e) => {
    console.log(e.target.value);
    setPasswordValue(e.target.value);
  };

  console.log('uuuu', loginValue);
  return (
    <>
      <div className="overlay">
        <div style={{ width: '100%', background: '#00398f', textAlign: 'center', padding: '1%', color: 'white' }}>
          <h2>Login Page</h2>
        </div>
        <form className="login-form">
          <div className="con">
            <header className="head-form">
              <h2>Log In</h2>

              <p>login here using your username and password</p>
            </header>

            <br />
            <div className="field-set">
              <span className="input-item">
                <i className="fa fa-user-circle" />
              </span>

              <input
                className="form-input"
                id="txt-input"
                type="text"
                name="username"
                required
                onChange={changeUsername}
              />

              <br />

              <span className="input-item">
                <i className="fa fa-key" />
              </span>

              <input
                className="form-input"
                type="password"
                placeholder="Password"
                id="pwd"
                name="password"
                required
                onChange={changePassword}
              />

              <span>
                <i className="fa fa-eye" aria-hidden="true" type="button" id="eye" />
              </span>

              <br />
              <Button
                // type="submit"
                onClick={() => {
                  loginUser(loginValue, passwordValue, setIsLoading, setError);
                }}
              >
                Login
              </Button>
            </div>
          </div>
        </form>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />
    </>
  );
}
